import React from 'react';
import { ButtonRadio, Field, Select} from '../Common';

export default class LegalInformationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.data.id ? props.data.id : '',
            idBeneficiaire: props.data.idBeneficiaire ? props.data.idBeneficiaire : '',
            testament: props.data.testament ? true : false,
            notary: props.data.notary ? true : false,
            firstName: props.data.firstName ? props.data.firstName : '',
            name: props.data.name ? props.data.name : '',
            idAddress: props.data.idAddress ? props.data.idAddress : '',
            address: props.data.address ? props.data.address : '',
            zipCode: props.data.zipCode ? props.data.zipCode : '',
            city: props.data.city ? props.data.city : '',
            codeCountry: props.data.codeCountry ? props.data.codeCountry : '79',
            tel: props.data.tel ? props.data.tel : '',
            error: {
                name: '',
                address: '',
                zipCode: '',
                city: '',
                tel: ''
            },
            countryList : props.countryData.list

        }
    }

    handleOnChange(key, e) {
        let value = e.target.value;
        if (e.target.type === "radio")
            value = e.target.value == "true" ? true : false;
        this.setState(() => ({ [key]: value }));
    }

    onSubmit = (e) => {
        e.preventDefault();
        let submit = false;
        if (!this.state.testament) {
            this.setState(() => ({ notary: false }));
        }
        if (!this.state.testament) {
            this.setState(() => ({
                firstName: '',
                name: '',
                address: '',
                zipCode: '',
                city: '',
                tel: '',
                codeCountry : '',
                idAddress : ''
            }));
            submit = true;
        }
        const name = (!this.state.name || this.state.name == '') ? ' is-invalid' : '';
        const firstName = (!this.state.firstName) ? ' is-invalid' : '';
        const address = (!this.state.address) ? ' is-invalid' : '';
        const zipCode = (!this.state.zipCode) ? ' is-invalid' : '';
        const city = (!this.state.city) ? ' is-invalid' : '';
        const tel = (!this.state.tel) ? ' is-invalid' : '';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                name,
                firstName,
                address,
                zipCode,
                city,
                tel
            }
        }))
        

        if (submit || (!name && !firstName && !address && !zipCode && !city && !tel ) )
            this.props.onSubmit({
                id: this.state.id,
                idBeneficiaire: this.state.idBeneficiaire,
                testament: this.state.testament,
                notary: this.state.notary,
                firstName: this.state.firstName,
                name: this.state.name,
                idAddress: this.state.idAddress,
                address: this.state.address,
                zipCode: this.state.zipCode,
                city: this.state.city,
                codeCountry: this.state.codeCountry,
                tel: this.state.tel
            });
    }


    render() {


        return (
            <form onSubmit={this.onSubmit} className="legal-info-form">
                <div className="row">
                    <div className="col-sm-5">
                    {
                        this.state.testament ?
                        <img src='/images/i-j-lg.png' alt="image profil" className="_lg " />
                        :
                        <img src='/images/i-j-first-lg.png' alt="image profil" className="_lg _first" />
                    }
                        <img src='/images/i-j-sm.png' alt="image profil" className="_sm" />
                    </div>
                    <div className="col-sm-7 form-container top-form">
                        <div className="form-group">
                            <label>J'ai rédigé un testament * :</label>
                            <ButtonRadio
                                type="radio"
                                _id="radio1"
                                name="testament"
                                className="custom-control-input"
                                value="true"
                                checked={this.state.testament}
                                onChange={this.handleOnChange.bind(this, 'testament')}
                                label="Oui"
                            />
                            <ButtonRadio
                                type="radio"
                                _id="radio2"
                                name="testament"
                                className="custom-control-input"
                                value="false"
                                checked={!this.state.testament}
                                onChange={this.handleOnChange.bind(this, 'testament')}
                                label="Non"
                            />
                        </div>
                        {    // IF TESTEMANT    
                            this.state.testament &&
                            <div>
                                <div className="form-group">
                                    <label>Le testament a été rédigé chez un notaire * :</label>
                                    <ButtonRadio
                                        type="radio"
                                        _id="radio3"
                                        name="notary"
                                        className="custom-control-input"
                                        value="true"
                                        checked={this.state.notary}
                                        onChange={this.handleOnChange.bind(this, 'notary')}
                                        label="Oui"
                                    />
                                    <ButtonRadio
                                        type="radio"
                                        _id="radio4"
                                        name="notary"
                                        className="custom-control-input"
                                        value="false"
                                        checked={!this.state.notary}
                                        onChange={this.handleOnChange.bind(this, 'notary')}
                                        label="Non"
                                    />
                                </div>
                                <div>
                                {    // IF NOTARY    
                                    this.state.notary &&
                                    <label>Mon notaire est : </label>                                    
                                    // END IF NOTARY
                                }
                                {    // IF NOTARY    
                                    !this.state.notary &&
                                    <label>Mon exécuteur testamentaire est : </label>                                    
                                    // END IF NOTARY
                                }
                                <Field
                                    type="text"
                                    _className={"form-control " + this.state.error.name}
                                    //placeholder="DUPOND"
                                    value={this.state.name}
                                    onChange={this.handleOnChange.bind(this, 'name')}
                                    error={this.state.error.name}
                                    label="Nom *"
                                />
                                <Field
                                    type="text"
                                    _className={"form-control " + this.state.error.firstName}
                                    //placeholder="ALAIN"
                                    value={this.state.firstName}
                                    onChange={this.handleOnChange.bind(this, 'firstName')}
                                    error={this.state.error.firstName}
                                    label="Prénom *"
                                />
                                <Field
                                    type="text"
                                    _className={"form-control address  " + this.state.error.address}
                                    //placeholder="1 rue de Charles de Gaule"
                                    value={this.state.address}
                                    onChange={this.handleOnChange.bind(this, 'address')}
                                    error={this.state.error.address}
                                    label="Adresse *"
                                />
                                <Field
                                    type="text"
                                    _className={"form-control " + this.state.error.zipCode}
                                    //placeholder="97860"
                                    value={this.state.zipCode}
                                    onChange={this.handleOnChange.bind(this, 'zipCode')}
                                    error={this.state.error.zipCode}
                                    label="Code postal *"
                                />
                                <Field
                                    type="text"
                                    _className={"form-control " + this.state.error.city}
                                    //placeholder="MARNY SUR OISE"
                                    value={this.state.city}
                                    onChange={this.handleOnChange.bind(this, 'city')}
                                    error={this.state.error.city}
                                    label="Ville *"
                                />
                                <Select
                                    label="Pays *"
                                    error={this.state.error.codeCountry}
                                    _className={"form-control address " + this.state.error.codeCountry}
                                    ////placeholder="France"
                                    value={this.state.codeCountry}
                                    onChange={this.handleOnChange.bind(this, 'codeCountry')}
                                    list={this.state.countryList}
                                    selectType ="obj"
                                    optionValue ="id"
                                    optionLabel ="libelle"
                                />
                                <Field
                                    type="text"
                                    _className={"form-control " + this.state.error.tel}
                                    //placeholder="0601020304"
                                    value={this.state.tel}
                                    onChange={this.handleOnChange.bind(this, 'tel')}
                                    error={this.state.error.tel}
                                    label="Téléphone *"
                                />
                            </div>
                            </div>
                            // END IF TESTEMANT
                        }
                        <div className="required-txt"> * Champs obligatoires</div>
                    </div>
                    <div className="col-sm-12 form-container align-center">
                        <div className="button-container">
                            <button onClick={this.props.back} className="btn btn-outline-primary">ANNULER</button>
                            <button type="submit" className="btn btn-primary">ENREGISTRER</button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/LegalInformationPage/LegalInformationForm.js